import { Map } from 'immutable'
import * as API from '../../utils/API'
import { loading, loadingSuccess, loadingFailure } from './status'
import mergePayload from './utils/mergePayload'

const RESOURCE_NAME = 'distribuidora'
const ENDPOINT = '/concessionarias'

const resolve = (dispatch, resource) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(loadingDistribuidoraSuccess(resource))
  return Promise.resolve(resource)
}

const resolveDestroy = (dispatch, id) => {
  dispatch(loadingSuccess(RESOURCE_NAME))
  dispatch(destroyingDistribuidoraSuccess(id))
  return Promise.resolve()
}

const reject = (dispatch, error) => {
  dispatch(loadingFailure(RESOURCE_NAME, error))
  return Promise.reject(error)
}

export const LOADING_DISTRIBUIDORA_SUCCESS = 'LOADING_DISTRIBUIDORA_SUCCESS'
export function loadingDistribuidoraSuccess(distribuidora) {
  return {
    type: LOADING_DISTRIBUIDORA_SUCCESS,
    distribuidora,
  }
}

export const DESTROYING_DISTRIBUIDORA_SUCCESS =
  'DESTROYING_DISTRIBUIDORA_SUCCESS'
export function destroyingDistribuidoraSuccess(distribuidoraId) {
  return {
    type: DESTROYING_DISTRIBUIDORA_SUCCESS,
    distribuidoraId,
  }
}

export function fetchMultipleDistribuidora() {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function fetchDistribuidora(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function createDistribuidora(distribuidora) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(ENDPOINT, 'POST', distribuidora).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function updateDistribuidora(id, distribuidora) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return API.call(`${ENDPOINT}/${id}`, 'PUT', distribuidora).then(
      resource => resolve(dispatch, resource),
      error => reject(dispatch, error)
    )
  }
}

export function destroyDistribuidora(id) {
  return async function (dispatch /* getState */) {
    dispatch(loading(RESOURCE_NAME))
    return await API.call(`${ENDPOINT}/${id}`, 'DELETE').then(
      () => resolveDestroy(dispatch, id),
      error => reject(dispatch, error)
    )
  }
}

const distribuidora = (state = new Map({}), action) => {
  switch (action.type) {
    case LOADING_DISTRIBUIDORA_SUCCESS: {
      const { distribuidora: payload } = action
      return mergePayload(state, payload)
    }

    case DESTROYING_DISTRIBUIDORA_SUCCESS:
      return state.delete(action.distribuidoraId.toString())

    default:
      return state
  }
}

export default distribuidora
